export default __webpack_public_path__ + "static/media/sell2.718877f4.png";